import React from 'react'

function PersonInfo ({title = null, description = null, image = null}) {
  const titleHtml = title ? <div className={'person-info__title'}>{title}</div> : null
  const descriptionHtml = description ? <p className={'person-info__desc'}>{description}</p> : null
  const imageHtml = image ? <div className={'person-info__image'}
                                   style={{ backgroundImage: 'url(' + image + ')' }}></div> : null

  return (
    <div className={'person-info'}>
      {imageHtml}
      <div className={'person-info__text'}>
        {titleHtml}
        {descriptionHtml}
      </div>
    </div>
  )
}

export default PersonInfo